module.exports = __webpack_public_path__ + "img/amblem.08229934.svg";